import { useParams } from "react-router-dom";
import { CameraList } from "./cam.list";
import AddCameraToHub from "./add.camera";

export const ClientHubCamera = () => {
  const { id } = useParams();

  return (
    <div>
      <h3>Список камер</h3>
      <div>
        <AddCameraToHub hubId={id} />
        <CameraList hubId={id} />
      </div>
    </div>
  );
};
